import { Checkbox, FormControlLabel } from "@mui/material";
import SelectField from "../widgets/Form/SelectField";
import Image from "next/image";
import IconCross from "../icons/IconCross";
import { ProductWishlistChipFragment } from "@graphcommerce/magento-wishlist/components/ProductWishlistChip/ProductWishlistChip.gql";
import { useCustomerQuery } from "@graphcommerce/magento-customer";
import { wishlistCategoriesDocument } from "../../graphql/wishlist/wishlistCategories.gql";
import { FormProvider, useForm } from "@graphcommerce/ecommerce-ui";
import SelectFieldElement from "../widgets/Form/SelectFieldElement";
import SimpleTextInput from "../widgets/Form/SimpleTextInput";
import SimpleTextArea from "../widgets/Form/SimpleTextArea";
import { useMutation } from "@graphcommerce/graphql";
import { addWishlistCategoryDocument } from "../../graphql/wishlist/addWishlistCategory.gql";
import { useLoading } from "../../context/loadingContext";
import { addProductsToWishlistDocument } from "../../graphql/wishlist/addProductsToWishlist.gql";
import { ProductListItemFragment } from "@graphcommerce/magento-product";
import { useWishlist } from "../../context/wishlistContext";
import { updateCustomerWishlistShowPopupDocument } from "../../graphql/wishlist/updateCustomerWishlistShowPopup.gql";
import { CheckboxElement } from "../widgets/Form/CheckboxElement";
import { ProductInterface } from "@graphcommerce/graphql-mesh";

type SummitWishList = {
  category_id: number | null | string;
  description?: string;
  name?: string;
  wishlist_show_popup?: boolean;
}


type AddToWishlistFormContentProps = (ProductListItemFragment | ProductInterface) & {
  small_image?: {
    url?: string | null | undefined
    label?: string | null | undefined
  } | null;


  onClick?: () => void;
  onClose: () => void;
  handleAddToWishlist: (des: string | null, category_id: string | null) => void
}


export default function AddToWishlistFormContent(props: AddToWishlistFormContentProps) {
  const { name, small_image, onClick, onClose, sku, om_english_title, handleAddToWishlist } = props;
  const { data, loading, refetch } = useCustomerQuery(wishlistCategoriesDocument, {
  });

  const [addWishlistCategory] = useMutation(addWishlistCategoryDocument);
  const methods = useForm()
  const { setLoading } = useLoading();
  const [setShowWishlistPopup] = useMutation(updateCustomerWishlistShowPopupDocument)

  const handleHiddenPopup = () => {
    setShowWishlistPopup({
      variables: {
        wishlist_show_popup: false
      }
    }).catch(err => alert(err.message));
  }
  const submitHandler = (values: any) => {
    const { category_id, name } = values as SummitWishList;


    setLoading(true);
    if (values.wishlist_show_popup === true) {
      handleHiddenPopup()
    }
    if (category_id === '0') {
      addWishlistCategory({
        variables: {
          name: name!
        }
      }).then(({ data, errors }) => {
        if (data?.addWishlistCategory?.id) {
          handleAddToWishlist(values.description, data?.addWishlistCategory?.id)
        } else if (errors && errors[0].message) {
          alert(errors[0].message)
        }
      }).catch((err) => {
        setLoading(false);
        alert(err.message);
      })
    } else {
      handleAddToWishlist(values.description, String(category_id))
    }


  }

  const categoryId = methods.watch('category_id');
  return (
    <div>
      <div className="flex justify-between items-center p-4 border-b border-solid">
        <p className="text-base font-medium text-default-900">افزودن به لیست علاقمندی</p>
        <IconCross width={22} height={22} className="text-light-400 cursor-pointer" onClick={() => onClose()} />
      </div>

      <div className="p-4">

        <div className="flex flex-col md:flex-row justify-between items-start md:items-center">
          <div className="w-20 h-20 border border-solid overflow-hidden">
            <Image width={80} height={80} alt={small_image?.label ? small_image.label : ''} src={small_image?.url ? small_image.url : ''} />
          </div>
          <div className="flex-1 flex flex-col justify-center">
            <h4 className="text-base text-light-400 md:mt-0 md:px-5">{name}</h4>
            <h6 className="text-sm text-light-400 mt-4 md:px-5">{om_english_title}</h6>
          </div>
        </div>

        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(submitHandler)}>
            <div className="flex flex-col md:flex-row justify-between mt-10 gap-[20px] md:gap-[5%]">
              <div className="w-full md:flex-1">
                <SelectFieldElement defaultValue={'favs'} control={methods.control} fullWidth label="" name="category_id">
                  <option value={'0'}>افزودن به دسته جدید</option>
                  {data?.wishlistCategories && data.wishlistCategories.map((item) => (
                    <option value={item?.id ?? 'favs'}>{item?.name}</option>
                  ))}
                </SelectFieldElement>
              </div>
              <div className="w-full md:flex-1 md:h-auto ">
                {categoryId === '0' && <SimpleTextInput name="name" required placeholder="نام دسته" />}
              </div>
            </div>

            <div className="mt-3">
              <SimpleTextArea rows={5} name="description" placeholder="توضیحات" />
            </div>

            <div className="flex flex-col md:flex-row justify-start md:justify-between mt-10">

              <CheckboxElement name="wishlist_show_popup" label="دیگر این پیام را نمایش نده." />
              {/*               <FormControlLabel name='wishlist_show_popup' control={<Checkbox />}   />
 */}              <div className="flex justify-end">
                <button type="submit" className="text-sm px-8 h-10 font-medium text-white bg-primary-500 hover:bg-primary-700 shadow-md">
                  افزودن
                </button>
              </div>
            </div>
          </form>
        </FormProvider>
      </div>
    </div>
  )
} 